import { isNone } from "./Maybe.js";
export const getLiveDirectiveNode = (input) => {
    var _a;
    if (input.kind !== "OperationDefinition" || input.operation !== "query") {
        return null;
    }
    const liveDirective = (_a = input.directives) === null || _a === void 0 ? void 0 : _a.find((d) => d.name.value === "live");
    if (isNone(liveDirective)) {
        return null;
    }
    return liveDirective;
};
